import React from 'react';

import { ChevronIcon } from '@icons';

import * as Styled from './faq-case.styled';

type OwnProps = {
	main: string;
	sub: string;
};

const FaqCase: React.FC<OwnProps> = ({ main, sub }) => {
	const [showMore, setShowMore] = React.useState<boolean>(false);

	return (
		<Styled.Wrapper>
			<Styled.Title onClick={() => setShowMore(!showMore)}>
				{main}
				<Styled.IconWrapper $isActive={showMore}>
					<ChevronIcon />
				</Styled.IconWrapper>
			</Styled.Title>
			<Styled.Subtitle $isShown={showMore} dangerouslySetInnerHTML={{ __html: sub }} />
		</Styled.Wrapper>
	);
};

export default FaqCase;
